import React from 'react';
import { Link } from 'react-router-dom';
import { Video, Mail, Phone, MapPin } from 'lucide-react';
import { TechtonAttribution } from './TechtonAttribution';

export function Footer() {
  const year = new Date().getFullYear();
  
  return (
    <footer className="border-t border-gray-800 py-12" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">Footer</h2>
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          <div>
            <Link to="/" className="flex items-center space-x-2 mb-4" aria-label="Techton Video Meetings - Go to homepage">
              <Video className="w-6 h-6 text-blue-400" aria-hidden="true" />
              <span className="text-xl font-bold">Techton Video Meetings</span>
            </Link>
            <p className="text-sm text-gray-400 mb-4">
              Connect with our team through secure, high-quality video meetings to discuss your project needs.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-blue-400" aria-hidden="true" />
                <a href="mailto:sales@techton.tech" className="text-gray-400 hover:text-white transition">sales@techton.tech</a>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-blue-400" aria-hidden="true" />
                <a href="tel:+15095612043" className="text-gray-400 hover:text-white transition">(509) 561-2043</a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-blue-400 mt-1" aria-hidden="true" />
                <address className="text-gray-400 not-italic">
                  Spokane, Washington 99208<br />
                  United States
                </address>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <p>&copy; {year} Techton. All rights reserved.</p>
          <TechtonAttribution className="mt-4 md:mt-0" />
        </div>
      </div>
    </footer>
  );
}